// One way to say how long something takes, everywhere a person reads it
// (aithlo-frontend#47): minutes under an hour ("45 min"), hours and minutes
// from an hour up ("8h 20m", "2h"). Nobody plans a ride in minutes past 90.
//
// Display only: stored strings ("500 minutes", estimated_duration) stay as
// they are, because Calendar.parseDuration and the session modal read them.

/** 45 → "45 min", 90 → "1h 30m", 120 → "2h", 500 → "8h 20m"; nothing → "". */
export function formatMinutes(min) {
  const m = Math.round(Number(min));
  if (!Number.isFinite(m) || m <= 0) return '';
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h}h ${r}m` : `${h}h`;
}

/** "500 minutes", "90 min", "1h 30m", "1h 30min", "PT1H30M", "75" → minutes, or null. */
export function parseMinutes(value) {
  if (typeof value === 'number') return Number.isFinite(value) && value > 0 ? value : null;
  if (typeof value !== 'string') return null;
  const s = value.trim().toLowerCase();
  if (!s) return null;
  if (/^\d+(\.\d+)?$/.test(s)) return Number(s) || null;
  const iso = s.match(/^pt(?:(\d+)h)?(?:(\d+)m)?$/);
  if (iso && (iso[1] || iso[2])) return Number(iso[1] || 0) * 60 + Number(iso[2] || 0);
  const h = s.match(/(\d+(?:\.\d+)?)\s*(?:h|hr|hrs|hour|hours)\b/);
  const m = s.match(/(\d+)\s*(?:m|min|mins|minute|minutes)\b/);
  if (!h && !m) return null;
  const total = (h ? Number(h[1]) * 60 : 0) + (m ? Number(m[1]) : 0);
  return total > 0 ? Math.round(total) : null;
}

/** A duration as stored (string or minutes) in the one convention; unreadable text is shown as it came. */
export function durationLabel(value) {
  const min = parseMinutes(value);
  if (min != null) return formatMinutes(min);
  return typeof value === 'string' ? value : '';
}
